import React, { useState } from "react";
import { ButtonFilled } from "./UIButtons";

const FingerPrintComponent = ({
  fingerprintData,
  setFingerprintData,
  setOpen,
}) => {
  const [status, setStatus] = useState("Idle");

  const registerFingerprint = async () => {
    setStatus("Requesting fingerprint...");

    try {
      const challenge = new Uint8Array(32);
      window.crypto.getRandomValues(challenge);

      const userId = new TextEncoder().encode("user-" + Date.now());

      const publicKey = {
        challenge,
        rp: {
          name: "My Local App",
        },
        user: {
          id: userId,
          name: "user@example.com",
          displayName: "Local User",
        },
        pubKeyCredParams: [
          { type: "public-key", alg: -7 },
          { type: "public-key", alg: -257 },
        ],
        authenticatorSelection: {
          authenticatorAttachment: "platform",
          userVerification: "required",
        },
        timeout: 60000,
        attestation: "none",
      };

      const credential = await navigator.credentials.create({ publicKey });

      if (credential) {
        console.log("✅ Credential:", credential);

        // Save to state (serialize ArrayBuffer as Base64 or hex if needed)
        setFingerprintData({
          id: credential.id,
          type: credential.type,
          rawId: btoa(String.fromCharCode(...new Uint8Array(credential.rawId))),
          response: {
            clientDataJSON: btoa(
              String.fromCharCode(
                ...new Uint8Array(credential.response.clientDataJSON)
              )
            ),
            attestationObject: credential.response.attestationObject
              ? btoa(
                  String.fromCharCode(
                    ...new Uint8Array(credential.response.attestationObject)
                  )
                )
              : null,
          },
        });

        setStatus("Fingerprint registered");
        setOpen(false);
      } else {
        setStatus("❌ No credential returned.");
      }
    } catch (err) {
      console.error("❌ Error:", err);
      setStatus("❌ Fingerprint registration failed: " + err.message);
    }
  };

  return (
    <div>
      <ButtonFilled onClick={registerFingerprint}>
        Register Fingerprint
      </ButtonFilled>
    </div>
  );
};

export default FingerPrintComponent;
